<template>
  <div class="form-group">
    <label
      v-bind:class="{ 'text-danger': current.errors.cotizacion && current.errors.cotizacion.length > 0 }"
    >Cotizacion</label>
    <v-select
      label="nombre"
      v-model="current.cotizacion"
      :disabled="disabled"
      :filterable="false"
      :options="cotizaciones"
      @search="onSearch"
    >
      <template slot="no-options">Cotizacion...</template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          <img :src="option.image" />
          Cotizacion #{{ option.numero }}  -||- Fecha: {{ option.fecha }}  
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          <img :src="option.image" />
          Cotizacion #{{ option.numero }}  -||- Fecha: {{ option.fecha }}  
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.cotizacion"
      class="form-text text-danger"
    >{{ current.errors.cotizacion[0] }}</small>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["current", "disabled"],
  computed: {
    ...mapGetters({
      cotizaciones: "cotizaciones/cotizaciones"
    })
  },
  mounted() {
    this.$store.dispatch("cotizaciones/fetch", {
      activo: true,
      quitar_paginacion: true,
      estado: 'B'
    });
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("cotizaciones/fetch  ", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search
      });

      loading(false);
    }, 350)
  }
};
</script>